/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var EyeOpenIcon16Solid = forwardRef('EyeOpenIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 2.324c-3.623 0-6.722 2.237-7.948 5.396-.07.18-.07.38 0 .56C1.278 11.44 4.377 13.676 8 13.676s6.722-2.237 7.948-5.396c.07-.18.07-.38 0-.56C14.722 4.56 11.623 2.324 8 2.324ZM8 4.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z" })));
});
